// Debug flag - set to true to see detailed logs
// Enable this when debugging custom view settings issues
export const DEBUG_CUSTOM_VIEW_SETTINGS = false;
export const debugLog = (...args) => DEBUG_CUSTOM_VIEW_SETTINGS && console.log('[CustomViewSettings]', ...args);
